import { StyleSheet } from 'react-native';
import { get, pick, omit } from 'lodash';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';

const createStyles = (attributes: any, Platform: any, isEmptyUrl: boolean) => {
  const hasPlaceholder = get(attributes, 'imageUrl.binding.options', {});
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style;

  const getBorderStyles = () => {
    // If image is empty and no placeholder is enabled, hide border
    if (isEmptyUrl && !hasPlaceholder?.placeholderImageEnabled) {
      return { borderWidth: 0 };
    }

    const isV4 = appInfo?.version === AppVersion.V4;
    // Determine border style based on app version
    const borderStyle = isV4
      ? attributes.style?.borderStyle
      : attributes.borderStyle;

    // If border style is 'none', hide border
    if (borderStyle === 'none') {
      return { borderWidth: 0 };
    }

    // Return border styles with fallbacks based on app version
    const borderWidth = isV4
      ? attributes.style?.borderWidth
      : attributes.borderWidth;
    const borderColor = isV4
      ? attributes.style?.borderColor
      : attributes.borderColor;
    const borderRadius = isV4
      ? attributes.style?.borderRadius
      : attributes.borderRadius;

    return {
      borderWidth,
      borderColor,
      borderStyle: borderStyle || attributes.borderStyle,
      borderRadius: borderRadius === 0 ? 1 : borderRadius,
    };
  };

  const getShadow = () => {
    if (!attributes.shadow) return {};
    return {
      shadowColor: attributes.shadow.color,
      shadowRadius: attributes.shadow.size,
      shadowOpacity: attributes.shadow.blur || 1,
      shadowOffset: {
        width: attributes.shadow.x,
        height: attributes.shadow.y,
      },
    };
  };

  return StyleSheet.create({
    container: {
      ...pick(attributes, ['zIndex', 'opacity']),
      ...(isV4
        ? pick(style, [
            'top',
            'left',
            'bottom',
            'right',
            'position',
            'width',
            'height',
            'transform',
            'margin',
            'marginTop',
            'margiBottom',
            'marginRight',
            'marginLeft',
          ])
        : pick(attributes, ['marginTop', 'marginLeft', 'width', 'height'])),
      ...getShadow(),
      zIndex: attributes.zIndex,
      ...getBorderStyles(),
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    wrapper: {},
    img: {
      width: '100%',
      height: '100%',
    },
  });
};

export default createStyles;
